export class BeanTypes {
  static Rect: string = "Rect";
  static Ellipse: string = "Ellipse";
  static Text: string = "Text";
  static MovableText: string = "MovableText";
  static CircleSelect: string = "CircleSelect";
  static Date: string = "Date";
  static Line: string = "Line";
  static FreeLine: string = "FreeLine";
  static Calculate: string = "Calculate";
  static Check: string = "Check";
  static List: string = "List";
  static Roll: string = "Roll";
  static Image: string = "Image";
  static Sign: string = "Sign";
  static ExternalData: string = "ExternalData";
  static ExternalProcess: string = "ExternalProcess";
  static Barcode: string = "Barcode";
  static PosCorrect: string = "PosCorrect";
  static RichText: string = "RichText";
  static Triangle: string = "Triangle";
  static MovableImage: string = "MovableImage";
  static Cross: string = "Cross";
  static NewPage: string = "NewPage";
  static JoinText: string = "JoinText";
  static Graph: string = "Graph";
  static HeaderFooterText: string = "HeaderFooterText";
  static Bar: string = "Bar";
  static Stamp: string = "Stamp";
}
